import { PageUtils } from "./helpers/page-utils";

window.addEventListener('load', event => {
    const featureImagePanels = document.querySelectorAll('.feature-image-panel');

    for (const featureImagePanel of featureImagePanels) {
        const featureImage = featureImagePanel.querySelector('.feature-image');

        // Zooms on lightbox image when hovered
        if (featureImage) {
            featureImage.addEventListener('mousemove', PageUtils.zoom);
        }
    }
});